<template>
  <div class="vehicle-tree" :class="[{'element--is-loading': !tree}]">
    <ul v-if="tree" class="vehicle-tree__tree" role="tree">
      <li
        v-for="node in tree"
        :key="node.code"
        role="treeitem"
        :style="nodeMargin"
        :class="['vehicle-tree__item', {'vehicle-tree__item--root': isRoot}]">
        <div :class="['vehicle-tree__content', {'vehicle-tree__content--root': isRoot}]">
          <oie-base-action
            v-if="node.nextLevel && node.nextLevel.length > 0"
            class="vehicle-tree__open"
            theme="flat"
            @click="toggleActiveChild(node)">
            <oie-base-icon icon="chevron-down" size="xs" :rotate="isActive(node) ? '180' : ''"></oie-base-icon>
          </oie-base-action>
          <div class="vehicle-tree__name">
            <oie-editable-content
              v-if="node.customModel"
              class="vehicle-tree__actions"
              :display-value="node.name"
              @change="updateCustomMachine({id: node.code, name: $event})"
              @delete="handleDelete(node.code, node.name)"></oie-editable-content>
            <p v-else class="body-bold">
              {{ `${node.name}*` }}
            </p>
            <oie-add-option-slide-in
              label-text="Namn på ny nodx"
              title="Lägg till ny nodx"
              :text="`Lägg till en ny nod under ${node.name}x`"
              @add-option="handleAddNewNode($event, node.code)">
              <template #activator="{open}">
                <oie-base-action theme="flat" @click="open">
                  <oie-base-icon icon="add" size="xs"></oie-base-icon>
                </oie-base-action>
              </template>
            </oie-add-option-slide-in>
          </div>
        </div>
        <template v-if="isActive(node)">
          <oie-my-machines-custom-vehicle-nodes-tree :nodes="node.nextLevel" :spacing="25"></oie-my-machines-custom-vehicle-nodes-tree>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    spacing: { type: Number, default: 0 },
    nodes: { type: Array, default: null }
  },
  data() {
    return {
      activeChildren: []
    }
  },
  computed: {
    ...mapGetters('myMachines', ['customVehicleNodes']),
    tree() {
      return this.nodes ? this.nodes : this.get(this.customVehicleNodes, 'nextLevel')
    },
    nodeMargin() {
      return {
        'margin-left': `${this.spacing}px`
      }
    },
    isRoot() {
      return this.spacing === 0
    }

  },
  mounted() {
    if(!this.nodes) {
      this.fetchCustomVehicleNodes()
    }
  },
  methods: {
    ...mapActions('myMachines', ['updateCustomMachine', 'deleteCustomMachine', 'fetchCustomVehicleNodes', 'addNewCustomNode']),
    ...mapActions('ui', ['setActiveSlideIn']),
    toggleActiveChild(child) {
      const index = _.findIndex(this.activeChildren, c => c.code === child.code)
      if(index === -1) {
        this.activeChildren.push(child)
      } else {
        this.activeChildren.splice(index, 1)
      }
    },
    isActive(child) {
      return _.some(this.activeChildren, c => c.code === child.code)
    },
    handleDelete(id, name) {
      this.publish('modal.show.generic', {
        header: `${this.t('deleteModalHeading')}: ${name}?`,
        text: this.t('typeWarningText'),
        buttons: [ {
          text: this.tStatic('genericDelete'),
          usePrimaryButton: true,
          handler: async () => {
            await this.deleteCustomMachine({ id: id })
            this.publish('modal.hide.generic')
          }
        }]
      })
    },
    async handleAddNewNode(name, parentCode) {
      await this.addNewCustomNode({ name, parentCode })
      this.setActiveSlideIn(null)
    }
  }
}
</script>

<style lang="scss">
.vehicle-tree {
  position: relative;
}

.vehicle-tree__tree {
  @include reset-list;
}

.vehicle-tree__item {
  background-color: color(background-gray);
}

.vehicle-tree__item--root {
  margin-bottom: measure(quarter);
  background-color: color(background-gray);
  border: 1px solid color(border-gray);
}

.vehicle-tree__content {
  position: relative;
  background-color: color(white);
  display: flex;
  gap: measure(quarter);
  align-items: center;
  height: 50px;
  width: 100%;
  padding: measure(quarter);
  border: 1px solid color(border-gray);
}

.vehicle-tree__content--root {
  background-color: color(background-gray);
  border: none;
}

.vehicle-tree__open {
  position: static;
}

.vehicle-tree__open::after {
  content: '';
  position: absolute;
  inset: 0;
}

.vehicle-tree__name {
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.vehicle-tree__name >*:first-child {
  flex-grow: 1;
}

.vehicle-tree__actions button {
  z-index: 2;
}
</style>
